import React, { useState } from "react";

import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { toast } from "react-hot-toast";
import { useMutation } from "react-query";

import { endpoint } from "../../../commonjs/endpoints";
import { RenderField, Spinner } from "../../../commonjs/components";
import { useCountryOptions } from "../../../commonjs/components/useCountryOptions";
import { NotificationTemplate } from "../../../layout/Layout";

/* Address forms (billing, delivery, invoice) */
export const AddressForm = ({ initialValues }) => {
  const { t } = useTranslation();
  const { countryOptions, isLoading } = useCountryOptions();
  // store current values to reset pristine state of the form
  const [values, setValues] = useState(initialValues);
  const notify = (msg) => toast.success(msg, { duration: 5000 });

  const { mutate: updateAdress } = useMutation({
    mutationFn: (addressData) =>
      endpoint("accounts:api_address_list", "POST", { body: addressData }),
    onSuccess: (data) => {
      // update locally store values to reset pristine state of the form
      setValues(data);
      notify(
        <NotificationTemplate
          title={t("Address data")}
          message={t("Address successfully changed.")}
        />
      );
    },
  });

  if (isLoading) return <Spinner />;

  const validateAddress = (values) => {
    const errors = {};
    if (!values.street_address) errors.street_address = t("Required");
    if (!values.postal_code) errors.postal_code = t("Required");
    if (!values.country_code) errors.country_code = t("Required");
    if (!values.city) errors.city = t("Required");
    return errors;
  };

  return (
    <Form
      initialValues={values}
      onSubmit={updateAdress}
      validate={validateAddress}
    >
      {({ handleSubmit, pristine, submitting, invalid }) => (
        <form onSubmit={handleSubmit}>
          <div className="grid">
            <fieldset>
              <div className="grid__item xs-12">
                <Field
                  name="street_address"
                  component={RenderField}
                  type="text"
                  placeholder={t("Street address")}
                />
              </div>
              <div className="grid__item sm-12 md-4">
                <Field
                  name="postal_code"
                  component={RenderField}
                  type="text"
                  placeholder={t("Postal code")}
                />
              </div>
              <div className="grid__item sm-12 md-8">
                <Field
                  name="city"
                  component={RenderField}
                  type="text"
                  placeholder={t("City")}
                />
              </div>
              <div className="grid__item xs-12">
                <Field
                  name="country_code"
                  component="select"
                  className="vertical-spacing-half"
                >
                  {countryOptions.map((x) => (
                    <option key={x.code} value={x.code}>
                      {x.name} ({x.code})
                    </option>
                  ))}
                </Field>
              </div>
              <div className="grid__item xs-12">
                <Field
                  name="address_details"
                  component={RenderField}
                  type="text"
                  placeholder={t("Address details")}
                />
              </div>
            </fieldset>
            <div className="grid__item xs-12">
              <button
                type="submit"
                disabled={pristine || submitting}
                className={`button button-primary ${pristine || submitting || invalid
                  ? "button-primary--disabled"
                  : "clickable"
                  }`}
              >
                {t("UPDATE")}
              </button>
            </div>
          </div>
        </form>
      )}
    </Form>
  );
};
